/**
 * Shared crash fallback. Used by both boot paths:
 *  - AppBootstrap wraps the authenticated app
 *  - main.tsx wraps the pre-gate render (landing + legal pages)
 *
 * Inline styles on purpose: this must render even if the stylesheet is the
 * thing that failed, and it must not depend on Tailwind classes being present.
 */
export default function ErrorFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'sans-serif',
        background: '#fafaf9',
      }}
    >
      <div style={{ textAlign: 'center', color: '#57534e' }}>
        <p style={{ fontSize: '1rem', fontWeight: 500 }}>Something went wrong</p>
        <p style={{ fontSize: '.875rem', marginTop: '.5rem' }}>
          An unexpected error occurred. Please reload the page.
        </p>
        <a
          href="/"
          style={{
            display: 'inline-block',
            marginTop: '1.5rem',
            padding: '.5rem 1rem',
            background: '#292524',
            color: '#fff',
            borderRadius: '.5rem',
            fontSize: '.875rem',
            textDecoration: 'none',
          }}
        >
          Reload
        </a>
      </div>
    </div>
  )
}
